module.exports = __webpack_public_path__ + "static/media/Yaxunah.436578b9.webp";